<app-breadcrumbs></app-breadcrumbs>
<section class="form-wrapper">
  <div class="form-with-cover">
    <div class="form-container">
      <div class="form-title-container">
        <h1>{{ contactFormData.title }}</h1>
        <p>{{ contactFormData.intro_copy }}</p>
      </div>

      <form
        *ngIf="claimForm && !showSuccessMessage"
        class="contact-form"
        [formGroup]="claimForm"
        (ngSubmit)="submit()"
      >
        <!-- Student name field -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="student_name">{{
                contactFormData.name_field_title
              }}</label>
            </div>

            <input
              formControlName="student_name"
              type="text"
              name="student_name"
              id="student_name"
              class="bg-grey"
              [class.error]="submitted && formControl['student_name'].errors"
            />
          </div>
        </div>

        <!-- Email field -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="email">{{ contactFormData.email_field_title }}</label>
            </div>

            <input
              formControlName="email"
              type="text"
              name="email"
              id="email"
              class="bg-grey"
              [class.error]="submitted && formControl['email'].errors"
            />
          </div>
        </div>

        <!-- Contact number field -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="contact_number">{{
                contactFormData.contact_field_title
              }}</label>
              <app-tooltip
                *ngIf="contactFormData.contact_field_tooltip"
                id="contact_field_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>

            <input
              type="tel"
              formControlName="contact_number"
              type="text"
              name="contact_number"
              id="contact_number"
              class="bg-grey"
              [class.error]="submitted && formControl['contact_number'].errors"
            />

            <span
              class="error"
              *ngIf="submitted && formControl['contact_number'].errors?.['pattern']"
            >
              {{ contactFormData.contact_field_validation }}
            </span>
          </div>
        </div>

        <!-- Centre name field -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="centre_name">{{
                contactFormData.centre_name_field_title
              }}</label>
            </div>

            <input
              formControlName="centre_name"
              type="text"
              name="centre_name"
              id="centre_name"
              class="bg-grey"
              [class.error]="submitted && formControl['centre_name'].errors"
            />
          </div>
        </div>

        <!-- Policy number field -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="policy_number">{{
                contactFormData.policy_number_field_title
              }}</label>
            </div>

            <input
              formControlName="policy_number"
              type="text"
              name="policy_number"
              id="policy_number"
              class="bg-grey"
              [class.error]="submitted && formControl['policy_number'].errors"
            />
          </div>
        </div>

        <!-- Language field -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="language">{{
                contactFormData.languages_field_title
              }}</label>
            </div>

            <select
              name="language"
              formControlName="language"
              id="language"
              [class.selected]="formControl['language'].dirty"
              [class.error]="submitted && formControl['language'].errors"
            >
              <option selected value="English">English</option>
              <ng-container *ngFor="let language of contactFormData.languages">
                <option [value]="language.name">
                  {{ language.name }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>

        <!-- Claim reason field -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="claim_reason">{{
                contactFormData.reason_for_claim_title
              }}</label>
            </div>

            <select
              name="claim_reason"
              formControlName="claim_reason"
              id="claim_reason"
              class="bg-grey"
              [class.selected]="formControl['claim_reason'].dirty"
              [class.placeholder]="formControl['claim_reason'].invalid"
              [class.error]="submitted && formControl['claim_reason'].errors"
            >
              <option disabled selected hidden value="">Please select</option>
              <option
                *ngFor="let reason of contactFormData.reasons_for_claim"
                [value]="reason.name"
              >
                {{ reason.name }}
              </option>
            </select>
            <span
              class="error"
              *ngIf="submitted && formControl['claim_reason']?.errors"
            >
              {{ contactFormData.reason_for_claim_validation }}
            </span>
          </div>
        </div>

        <!-- Description Validation -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="description">{{
                contactFormData.description_field_title
              }}</label>
            </div>

            <textarea
              formControlName="description"
              type="text"
              name="description"
              id="description"
              class="bg-grey"
              [attr.placeholder]="contactFormData.description_field_example"
              [class.error]="submitted && formControl['description']?.errors"
              maxlength="2000"
            >
            </textarea>

            <span
              class="error"
              *ngIf="submitted && formControl['description'].errors"
            >
              {{ contactFormData.description_field_validation }}
            </span>
          </div>
        </div>
        <button class="button">Submit</button>
      </form>

      <div *ngIf="showSuccessMessage" class="submit-success">
        <div class="seperator"></div>
        <p class="success-message">
          {{ contactFormData.successful_submission_message }}
        </p>
      </div>
    </div>

    <div class="cover-container" *ngIf="contactFormData?.cover_image">
      <img
        [src]="contactFormData.cover_image.data.attributes.url"
        alt="Registration Cover Image"
      />
    </div>
  </div>

  <app-modal [(show)]="showTooltipModel" [showBuddy]="false">
    <app-tooltip-modal [content]="tooltipModalContent"></app-tooltip-modal>
  </app-modal>
</section>
